import React, { memo } from 'react';
import Svg, { Path } from 'react-native-svg';

export const IconRadioUnchecked = memo(
  ({ size = 20, color = '#9b9b9b', ...rest }) => {
    return (
      <Svg width={size} height={size} viewBox="0 0 20 20" {...rest}>
        <Path
          fill={color}
          fillRule="evenodd"
          d="M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 14c-3.314 0-6-2.686-6-6s2.686-6 6-6c3.314 0 6 2.686 6 6s-2.686 6-6 6z"
        />
      </Svg>
    );
  }
);
